// Česká typografie při vykreslení textů (DES-003 §9, zadání 17): nezlomitelná mezera po
// jednopísmenných předložkách a spojkách a před % a Kč. Ostatní jazyky se nemění.

const NBSP = String.fromCharCode(0xa0);
// `{` kvůli větvím zpráv ICU v textech rozhraní („{count, plural, =1 {V jedné …}}“).
const SINGLE = /(?<=^|[\s(„"{])([KkSsVvZzOoUuAaIi]) +/g;
const UNIT = /(\d) +(%|Kč)/g;

export function typeset(text: string, locale: string): string {
  if (locale !== "cs") return text;
  return text.replace(SINGLE, `$1${NBSP}`).replace(UNIT, `$1${NBSP}$2`);
}

/** Velké první písmeno podle pravidel jazyka (jméno typu na začátku věty). */
export function capitalize(text: string, locale: string): string {
  const first = text.slice(0, 1);
  return first === "" ? text : first.toLocaleUpperCase(locale) + text.slice(1);
}
